import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const ServiceRecordDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsServiceRecordDetails" */ 'modules/activityDetails/ServiceRecordDetails/pages/ServiceRecordDetails'
    )
)

const ServiceRecordDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route
        exact
        path={`${routes.root}/:competenceId/:serviceRecordId`}
        component={ServiceRecordDetails}
      />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default ServiceRecordDetailsRouting
